import { render, staticRenderFns } from "./EditSynonyms.vue?vue&type=template&id=581e33f8&scoped=true"
import script from "./EditSynonyms.vue?vue&type=script&lang=js"
export * from "./EditSynonyms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581e33f8",
  null
  
)

export default component.exports